<template>
  <div
    :style="small ? 'margin-top: 80px !important;' : ''"
    class="comment__item"
  >
    <v-card class="half-radius py-5 px-10 shadow relative">
      <div v-if="!small" class="triangle"></div>
      <v-avatar
        class="shadow pa-1"
        size="50"
        :class="{ toLeft: !small, toTop: small }"
      >
        <v-img contain :src="src" alt="Arches"></v-img>
      </v-avatar>
      <p class="title font-weight-bold mb-0">
        <slot name="title">Speaking Prompts</slot>
      </p>
      <p class="subtitle-1 font-weight-bold">
        <slot name="subtitle"></slot>
      </p>
      <p>
        <slot name="body">
          <app-editor :editable="editable" :value="body" :class="downloadKey" />
        </slot>
      </p>
      <app-button-player
        v-if="audioSrc"
        :src="audioSrc"
        :size="24"
        class="to-the-top"
      />
      <template v-if="download || downloadKey">
        <v-divider class="my-3" />
        <v-row>
          <v-btn
            v-if="downloadKey"
            text
            class="text-capitalize body-2"
            @click="downloadComment"
          >
            Download Comment
            <v-icon right>$vuetify.icons.appDownload</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="download"
            text
            class="text-capitalize body-2"
            :loading="downloadingLoading"
            @click="downloadAudio"
          >
            Download Audio
            <v-icon right>$vuetify.icons.appDownload</v-icon>
          </v-btn>
        </v-row>
      </template>
      <div>
        <slot name="extra-buttons" />
      </div>
    </v-card>
  </div>
</template>
<script>
import Editor from '@/components/Utils/Editor.vue';
import audioMixin from '@/mixins/audioMixin';
import ButtonPlayer from './ButtonPlayer.vue';
import { getAudio } from '@/api/api';
import jsPdf from 'jspdf';

export default {
  components: {
    appEditor: Editor,
    appButtonPlayer: ButtonPlayer,
  },
  mixins: [audioMixin],
  props: {
    audioSrc: {
      required: false,
      type: String,
      default: '',
    },
    src: {
      required: false,
      type: String,
      default: require('@/assets/logo_text_bellow.png'),
    },
    download: {
      required: false,
      default: false,
      type: Boolean,
    },
    downloadKey: String,
    body: {
      required: false,
    },
    editable: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      downloadingLoading: false,
    };
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onClick() {
      if (!this.playing) {
        this.audioUrl = this.audioSrc;
        this.audioPlay();
      } else {
        this.audioNoPlay();
      }
    },
    downloadComment() {
      let pdfName = 'Comment-' + new Date().toISOString();
      var doc = new jsPdf();
      doc.fromHTML(
        document.querySelector(
          `.comment__item .${this.downloadKey} .ProseMirror`,
        ).innerHTML,
        15,
        15,
        {
          width: 170,
        },
      );
      doc.save(pdfName + '.pdf');
    },
    async downloadAudio() {
      try {
        this.downloadingLoading = true;
        let anchor = document.createElement('a');
        const item = await getAudio(this.audioSrc);
        anchor.href = URL.createObjectURL(new Blob([item.data]));
        anchor.target = '_blank';
        anchor.download = new Date().toISOString() + '.webm';
        anchor.click();
        this.downloadingLoading = false;
      } catch (error) {
        this.downloadingLoading = false;
        throw error;
      }
    },
  },
};
</script>
<style scoped lang="scss">
$width: 40px;
$angle: 0deg;
$offset: 6px;
.toLeft {
  left: -65px;
  top: 0;
}
.toTop {
  top: -60px;
  left: 10px;
}

.v-avatar {
  position: absolute;
  border-radius: 50% !important;
  background-color: white;
}

.triangle {
  position: absolute;
  width: $width;
  height: $width;
  // border: 1px solid blue;
  border-radius: 0px !important;
  left: -$width;
  top: 5px;
  overflow: hidden;
}
.triangle::after {
  content: '';
  position: absolute;
  width: $width;
  height: $width;
  left: $width - $offset + 3px;
  // border: 1px solid red;
  border-radius: 4px;
  transform: rotateX(50deg) rotatez(45deg);
  background-color: white;
  box-shadow: 0px 3px 6px #0000001a !important;
}
.to-the-top {
  position: absolute;
  top: 10px;
  right: 30px;
}
</style>
